import { createSelector } from '@ngrx/store';
import { AppState } from '@mob-store/reducers/app.reducer';
import { SettingsState } from '@mob-store/reducers/settings.reducer';
import { BootstrapSettings, CustomizedLabels } from '@models/models';

export const getSettingsState = (state: AppState): SettingsState =>
	state.settings;

export const getSettingsInfo = (state: SettingsState): BootstrapSettings =>
	state.settings;

export const getCustomisedLabelsState = (
	state: SettingsState
): CustomizedLabels => state.labels;

export const getBootstrapSettings = createSelector(
	getSettingsState,
	getSettingsInfo
);

export const getCustomizedLabels = createSelector(
	getSettingsState,
	getCustomisedLabelsState
);



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./mobile/src/store/selectors/settings.selector.ts